import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import useDidMount from 'app/hook/common/useDidMount';
import useNow from 'app/hook/common/useNow';
import useToast from 'app/hook/common/useToast';

function NotyTimezoneAlert({ dataName = null }) {
	const { pathname } = useLocation();
	const { getNow } = useNow();
	const { notyView } = useToast();

	const [dataArray, setDataArray] = useState([]);

	// 데이터 확인
	useDidMount(() => {
		let checkJsLoadTime;
		try {
			let count = 0;
			checkJsLoadTime = setInterval(() => {
				if (global[dataName] !== undefined) {
					setDataArray(global[dataName]);
					clearInterval(checkJsLoadTime);
				}
				count += 1;
				if (count > 50) {
					clearInterval(checkJsLoadTime);
					console.log('NotyTimezoneAlert: not working');
				}
			}, 150);
		} catch (err) {
			console.log(err);
		}
		return () => {
			clearInterval(checkJsLoadTime);
		};
	});

	// 알림
	const showTime = useCallback(
		async (data) => {
			const nowDateTime = await getNow();
			const today = nowDateTime;
			const startTime = new Date(data.start);
			const endTime = new Date(data.end);

			return today >= startTime && today <= endTime;
		},
		[getNow],
	);
	const messageView = useCallback(
		async (data) => {
			const envCheck = data.env.indexOf(process.env.REACT_APP_DEPLOY_ENV);
			if (envCheck < 0) return;

			// pathname 비교
			const makeRegExp = data.pathName?.replace(/\*/gi, '[a-z0-9]+'); // pathname의 *를 정규식(영어+숫자)으로 변경
			const pathNameCompare = new RegExp(`${makeRegExp}$`, 'gi').test(pathname);

			if (!pathNameCompare || !(await showTime(data))) return;
			if (data.type === 'alert' || !data.type) {
				alert(data.message);
				return;
			}
			if (data.type === 'toast') {
				notyView({
					id: 'timezoneAlert',
					text: data.message || '',
					timeout: data.toastTime,
					layout: data.toastLayout || 'center',
				});
			}
		},
		[pathname, showTime, notyView],
	);

	useEffect(() => {
		if (dataArray.length > 0) {
			dataArray.map((v) => messageView(v));
		}
	}, [dataArray, messageView]);

	return null;
}

export default NotyTimezoneAlert;
